import { render } from "./CambiarPasswordView.vue?vue&type=template&id=aa1e4d66&ts=true"
import script from "./CambiarPasswordView.vue?vue&type=script&lang=ts"
export * from "./CambiarPasswordView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__